import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IStickySectionProps } from '../components/sticky-sections-wrapper/sticky-section/sticky-section';

export class StickySectionModel extends ContentItem {
  get content(): IKontentItem[] {
    return get(this._config, 'elements.content.value', []);
  }

  get sectionId(): IKontentItem[] {
    return get(this._config, 'elements.section_id.value', '');
  }

  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      ''
    );
  }

  public static create(data: IStickySection): IStickySectionProps {
    const { content, backgroundColor, sectionId } = new StickySectionModel(
      data
    );
    return {
      content,
      backgroundColor,
      sectionId
    };
  }
}
